
import { S3Attachment, SaleEmailTemplate } from "@/models/sale-email-template";
import { MessagesService } from "@/services/messages-service";
import Vue from "vue";
import { IBreadCrumb, ISelectItem } from "winfakt-vue-components";

import AppMobileFullScreenContainer from "@/components/common/MobileFullScreenContainer.vue";
import AppToolbar from "@/components/common/ToolbarBase.vue";
import AppMailTemplateEdit from "@/components/mail-template-editor/MailTemplateEdit.vue";
import { AuthService } from "@/services/auth-service";
import { Tier } from "@/utils/payments/tiers";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";

export default Vue.extend({
	data() {
		return {
			template: new SaleEmailTemplate(),
			toUploadFiles: [] as File[],
			toRemoveFiles: [] as S3Attachment[],
			isSaving: false,
		};
	},
	computed: {
		crumbs(): IBreadCrumb[] {
			return [
				{
					to: "/settings/sales",
					value: this.$ct("sale/purchase"),
				},
				{
					to: "/settings/sales/mails",
					value: this.$ct("mails"),
				},
				{
					value: this.$ct("template"),
				},
			] as IBreadCrumb[];
		},
		allFiles(): ISelectItem<File | S3Attachment>[] {
			let result: ISelectItem<File | S3Attachment>[] =
				this.template.Attachments.filter(
					(f) => this.toRemoveFiles.indexOf(f) == -1
				).map((f) => {
					return {
						text: f.FileName,
						value: f,
					};
				});

			result.push(
				...this.toUploadFiles.map((f) => {
					return {
						text: f.name,
						value: f,
					};
				})
			);

			return result;
		},
		canUploadAttachment():boolean {
			return AuthService.hasAccessToMicroModule(2021, 9, 1);
		}
	},
	methods: {
		async save() {
			this.isSaving = true;
			try {
				if (this.template.ID == 0) {
					var [template] = await MessagesService.postSaleTemplates([this.template]);
				} else {
					var template = await MessagesService.putSaleTemplate(this.template);
				}
				let toRemoveFiles = [...this.toRemoveFiles];
				for (let i = toRemoveFiles.length - 1; i >= 0; i--) {
					let toRemoveFile = toRemoveFiles[i];
					template = await MessagesService.saleTemplateRemoveAttachment(template, toRemoveFile.Key);
					toRemoveFiles.splice(i, 1);
				}
				let toUploadFiles = [...this.toUploadFiles];
				for (let i = toUploadFiles.length - 1; i >= 0; i--) {
					let toUploadFile = toUploadFiles[i];
					template = await MessagesService.saleTemplateAddAttachment(template, toUploadFile);
					toUploadFiles.splice(i, 1);
				}
				this.template = template;
				this.toRemoveFiles = toRemoveFiles;
				this.toUploadFiles = toUploadFiles;
				this.$wf.notify(this.$ct("template-saved").toString(), "success", 3000, "check");
			} catch (err) {
				let error = err as any;
				if (error.message){
					this.$wf.notify(error.message, "danger", 3000, "exclamation-triangle");
				}else{
					this.$wf.notify(this.$ct("save-error").toString(), "danger", 3000, "exclamation-triangle");
				}
			}
			this.isSaving = false;
		},
		canUseReadNotifications() {
			return AuthService.wfCompany.Tier >= Tier.PROFESSIONAL;
		},
		onFile(file: File) {
			if (this.allFiles.length >= 3) {
				this.$wf.notify(
					this.$ct("error-max-files-reached", { maxFiles: 3 }),
					"danger",
					3000,
					"exclamation-triangle"
				);
				return;
			}
			this.toUploadFiles.push(file);
		},
		removeFile(file: S3Attachment | File) {
			if ((file as S3Attachment).Key) {
				this.toRemoveFiles.push(file as S3Attachment);
			} else {
				console.log(file);
				this.toUploadFiles = this.toUploadFiles.filter(
					(f) => f != file
				);
			}
		},
	},
	async mounted() {
		if (this.$route.params.id) {
			this.template = await MessagesService.getSaleTemplate(
				parseInt(this.$route.params.id)
			);
		}
	},
	components: {
		AppMailTemplateEdit,
		AppMobileFullScreenContainer,
		AppToolbar,
		AppFileUpload,
	},
	i18nEx: {
		componentPrefix: "components.sale-settings",
	},
});
